// extracted by mini-css-extract-plugin
export default {"container":"icon_container__hihkK","vercon":"icon_vercon__nLunJ","certificate":"icon_certificate__EL8Mo","check":"icon_check__4uslu"};